import moment from "moment";
import React, { useState } from "react";
import { Translate } from "react-localize-redux";
import HistoryDropdown from "./components/HistoryDropdown";
import HistoryRangePicker from "./components/RangePicker";
import HistoryContent from "./containers/HistoryContent";
import { HistoryWrapper, ItemWrapper } from "./elements";

const HistoryV2 = () => {
	const [values, setValues] = useState({
		type: "game",
		dateRange: [moment().subtract(1, "months"), moment()],
	});

	return (
		<Translate>
			{({ translate }) => (
				<HistoryWrapper>
					<ItemWrapper>
						<HistoryRangePicker
							translate={translate}
							onChange={(ranges) => setValues({ ...values, dateRange: ranges })}
						/>
						<HistoryDropdown
							selectedItem={values.type}
							onSelect={(item) => setValues({ ...values, type: item })}
							translate={translate}
						/>
					</ItemWrapper>
					<HistoryContent
						translate={translate}
						values={values}
					/>
				</HistoryWrapper>
			)}
		</Translate>
	);
};

export default HistoryV2;
